/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { memo, useMemo, lazy, useRef } from 'react';
import { Route, Routes, BrowserRouter, useLocation, Navigate } from 'react-router-dom';
import LazyWithRetry from './libs/LazyWithRetry';
import { useSelector } from 'react-redux';
import { roleCondition, canAccessBusinessProspects } from './libs/HelperContent';
import AuthHoc from './Layouts/AuthHoc';
import CompanyHoc from './Layouts/CompanyHoc';
import UnAuthHoc from './Layouts/TrainingHoc';
import EmployeePendingHoc from './Layouts/EmployeePendingHoc';
import CertificationExamHoc from './Layouts/CertificationExamHoc';
import HeaderSidebarLayoutHoc from './Layouts/HeaderSidebarLayoutHoc';
import Loading from './components/Common/Loaders/FullWidthLoader/Loading';
import PageNotFound from './UiComponents/PageNotFound';
import DeclinedAccess from './UiComponents/DeclinedAccess';
// LicenseManagement component which we are not using.
import LicenseManagement from './containers/LicenseManagement/index';
import BuyLicensesCards from './containers/LicenseManagement/components/BuyLicensesCards';
import PlaceYourOrder from './containers/LicenseManagement/components/PlaceYourOrder';
// import HTMLTemplate from './containers/MediaDriveNew/Components/Creation/index';
// import HTMLTemplateTwo from './containers/MediaDriveNew/Components/Creation/Components/TemplateTwo';
// import HTMLTemplateThree from './containers/MediaDriveNew/Components/Creation/Components/TemplateThree';
// import HTMLTemplateFour from './containers/MediaDriveNew/Components/Creation/Components/TemplateFour';
// import HTMLTemplateFive from './containers/MediaDriveNew/Components/Creation/Components/TemplateFive';
// import HTMLTemplateSix from './containers/MediaDriveNew/Components/Creation/Components/TemplateSix';
import BrandingPreview from './containers/Webinar/Components/ScheduleWebinar/Components/Branding/Components/BrandingPreview/index';
import RegisterPreview from './containers/Webinar/Components/ScheduleWebinar/Components/RegisterPreview/index';
import MeetingVc from './containers/Meetings/Components/MeetingVc';
import WebinarVc from './containers/Webinar/Components/WebinarVc';
import ScheduleLayout from './containers/Webinar/Components/ScheduleWebinar';
import { useSelect } from '@mui/base';
import { toast } from 'react-toastify';
import useRouteHelper from './libs/CustomHooks/useRouteHelper';
import ContentSectionView from './containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/ContentSectionView';

// Import ContentRouteWrapper
import ContentRouteWrapper from './containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Reusable/ContentRouteWrapper';

const ArticleViewPage = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/ContentSectionView/ArticleViewPage'));
const DocumentViewPage = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/ContentSectionView/DocumentViewPage'));
const PodcastViewPage = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/ContentSectionView/PodcastViewPage'));
const VideoViewPage = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/ContentSectionView/VideoViewPage'));
const ImageViewPage = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/ContentSectionView/ImageViewPage'));
const PlaylistViewPage = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/ContentSectionView/PlaylistViewPage'));

const OutsideInlynk = LazyWithRetry(import('./containers/BusinessSettings/Components/Inlynk/OutsidePage'));
const InsideinLynk = LazyWithRetry(import('./containers/BusinessSettings/Components/Inlynk/InsideinLynk'));
const LearningScreen = LazyWithRetry(import('./containers/CertificationManagement/Components/LearningScreen'));
const Languages = LazyWithRetry(import('./containers/Settings/components/Languages'));
const ChangePassword = LazyWithRetry(import('./containers/Settings/components/ChangePassword'));
const ForgotPassword = LazyWithRetry(import('./AuthenticationPages/ForgotPassword'));
const LoginPage = LazyWithRetry(import('./AuthenticationPages/LoginPage/index'));
const OtpVerify = LazyWithRetry(import('./AuthenticationPages/OtpVerify/index'));
const PasswordReset = LazyWithRetry(import('./AuthenticationPages/PasswordReset/index'));
const Signup = LazyWithRetry(import('./AuthenticationPages/SignUp'));
const Company = LazyWithRetry(import('./AuthenticationPages/SignUp/components/Company'));
const CompanyNew = LazyWithRetry(import('./AuthenticationPages/SignUp/components/CompanyNew'));
const Employee = LazyWithRetry(import('./AuthenticationPages/SignUp/components/Employee'));
const EmployeeNew = LazyWithRetry(import('./AuthenticationPages/SignUp/components/EmployeeNew'));
const Individual = LazyWithRetry(import('./AuthenticationPages/SignUp/components/Individual'));
const IndividualNew = LazyWithRetry(import('./AuthenticationPages/SignUp/components/IndividualNew'));
const SucessScreen = LazyWithRetry(import('./AuthenticationPages/SucessScreen/index'));
const EmailChange = LazyWithRetry(import('./containers/ProfileSettings/EmailChange/index'));
const Departmentview = LazyWithRetry(import('./containers/BusinessSettings/Components/Department/Components/View'));
const Policy = LazyWithRetry(import('./containers/Policy'));
const EmpNetworkConnection = LazyWithRetry(import('./containers/EmployeeMangement/components/EmpNetworkConnection'));
const Newslist = LazyWithRetry(import('./containers/NewsFeedRevised/index'));
const EmpManagement = LazyWithRetry(import('./containers/EmployeeMangement/index'));
const EmpProfile = LazyWithRetry(import('./containers/EmployeeMangement/components/ProfileDetails/EmpProfile'));
// const Contacts = LazyWithRetry(import('./containers/Contacts/index'));
const Collaboration = LazyWithRetry(import('./containers/CollaborationRevised/index'));
const OthersEmployeeProfile = LazyWithRetry(import('./containers/Networks/Components/UserProfile'));
const Contacts = LazyWithRetry(import('./containers/Contacts/index'));
// const PendingRequest = LazyWithRetry(import('./containers/Connections/components/PendingRequest/index'));
// const Following = LazyWithRetry(import('./containers/Connections/components/ConnectionFollowing/index'));
const AffiliateManagement = LazyWithRetry(import('./containers/AffiliateManagement/index'));
const AffiliateProductList = LazyWithRetry(import('./containers/AffiliateManagement/components/AffiliateProductList'));
const Communication = LazyWithRetry(import('./containers/Collaboration/index'));
const ExamLayout = LazyWithRetry(import('./containers/CertificationManagement/CertificationExams/index'));
const Affilaite = LazyWithRetry(import('./containers/Affiliate/index'));
const EmployeePending = LazyWithRetry(import('./UiComponents/EmployeePending/index'));
const AccessDenied = LazyWithRetry(import('./UiComponents/DeclinedAccess/index'));
const SelfProfile = LazyWithRetry(import('./containers/MyProfile/index'));
const MyProfile = LazyWithRetry(import('./containers/MyProfile/index'));
const Dealopportunity = LazyWithRetry(import('./containers/DealOpportunity/index'));
const DealViewDetails = LazyWithRetry(import('./containers/DealOpportunity/components/DealView'));
const Products = LazyWithRetry(import('./containers/Products/index'));
const Recognition = LazyWithRetry(import('./containers/Recognition/index'));
const JoinDetails = LazyWithRetry(import('./containers/TrainingWebinar/components/JoinDetails/index'));
const Highlights = LazyWithRetry(import('./containers/NewsFeed/Events/index'));
const TrainingWebinar = LazyWithRetry(import('./containers/TrainingWebinar/index'));
const TrainingDetails = LazyWithRetry(import('./containers/TrainingWebinar/components/JoinDetails/index'));
const TraningWebnirScreen = LazyWithRetry(import('./containers/TrainingWebinar/TWScreen/index'));

// content management | resources new
const ContentManagement = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/index'));
const CreationDocument = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Creation/Document/index'));
const CreationVideo = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Creation/Video/index'));
const CreationPodcast = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Creation/Podcast/index'));
const CreationImage = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Creation/Image/index'));
const CreationArticle = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Creation/ArticleEditor/index'));
const ContentManagementCategiries = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/CategoriesView/index'));
// const ContentManagementDrafts = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/DraftView/index'));
// const ContentManagementUncategory = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/Uncategory/index'));
// const ContentManagementPublished = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/Published/index'));
// const ContentManagementUnPublished = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/UnPublished/index'));
// const ContentManagementSchedule = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/Scheduled/index'));
// const ContentManagementPlaylist = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/PlayList/index'));

// certification management
const CertificationManagement = LazyWithRetry(import('./containers/CertificationManagement/index'));
const CertificationManView = LazyWithRetry(import('./containers/CertificationManagement/Components/CertificationView/index'));
const CreateCertificate = LazyWithRetry(import('./containers/CertificationManagement/Components/CreateCertification/index'));

// resources old
const ResourceManagement = LazyWithRetry(import('./containers/ResourceManagement/index'));
const ResourceConfig = LazyWithRetry(import('./containers/BusinessSettings/Components/RevisedResources/ResourceConfiguration'));
const ResourceRevised = LazyWithRetry(import('./containers/ResourcesRevised/index'));

// content management old
const ContentManagementOld = LazyWithRetry(import('./containers/ContentManagement/index'));
const NewResourcesCategoryView = LazyWithRetry(import('./containers/ContentManagement/Components/ViewCategoryDetails'));
const NewResourceContentCreation = LazyWithRetry(import('./containers/ContentManagement/Content/ContentCreation'));
const NewResourceContentView = LazyWithRetry(import('./containers/ContentManagement/Content/ContentCardView'));

const ViewSubCategoryVideo = LazyWithRetry(import('./containers/ResourceManagement/Components/MyResources/Components/MyVideo/Components/IndividualVideoCategory'));
const ViewSubCategoryContent = LazyWithRetry(import('./containers/ResourceManagement/Components/MyResources/Components/MyContent/Components/IndividualContentCategories'));
const ViewSubCategoryDocument = LazyWithRetry(import('./containers/ResourceManagement/Components/MyResources/Components/MyDocument/Components/IndividualDocumentCategory'));
const ViewSubCategoryPodcast = LazyWithRetry(import('./containers/ResourceManagement/Components/MyResources/Components/MyPodcast/Components/IndividualProdcastCategory'));
const NewResourceCategoryView = LazyWithRetry(import('./containers/ResourceManagement/Components/MyResources/Components/CategoryView'));
const NetworkCompanyPage = LazyWithRetry(import('./containers/ResourceManagement/Components/NetworkResources/Components/NetworkCompanyPage/index'));
const BookSeat = LazyWithRetry(import('./TrainingWebinarJoinVC/Components/RightBlock/BookSeat'));
const Registration = LazyWithRetry(import('./TrainingWebinarJoinVC/Components/RightBlock/Registration'));
const RequestBookSeat = LazyWithRetry(import('./TrainingWebinarJoinVC/Components/RightBlock/RequestBookSeat'));
const StartTraining = LazyWithRetry(import('./TrainingWebinarJoinVC/Components/RightBlock/StartTraining'));
const LoginWebinar = LazyWithRetry(import('./TrainingWebinarJoinVC/Components/RightBlock/LoginWebinar'));
const JoinWebinar = LazyWithRetry(import('./TrainingWebinarJoinVC/Components/RightBlock/JoinWebinar'));
const MediaDrive = LazyWithRetry(import('./containers/MediaDrive/index'));
const NewDesignCreation = LazyWithRetry(import('./containers/MediaDrive/components/NewDesignCreation'));
const BusinessProspectsEnabler = LazyWithRetry(import('./containers/BusinessProspectsEnabler/index'));
const ProductWarrantySettings = LazyWithRetry(import('./containers/ProductWarranty/Components/AutoValidation/Autovalidation'));
const ProductWarrantyView = LazyWithRetry(import('./containers/ProductWarranty/Components/View/index'));
const BusinessSettingsMenu = LazyWithRetry(import('./containers/BusinessSettings/Components/Menu'));
const SupportTicket = LazyWithRetry(import('./containers/BusinessSettings/Components/SupportTicketing/index'));
const BussinessCertification = LazyWithRetry(import('./containers/BusinessSettings/Components/BussinessCertification'));
const CustomLogo = LazyWithRetry(import('./containers/BusinessSettings/Components/CustomLogo'));
const Department = LazyWithRetry(import('./containers/BusinessSettings/Components/Department'));
const productWarranty = LazyWithRetry(import('./containers/BusinessSettings/Components/ProductWarranty'));
const Relation = LazyWithRetry(import('./containers/BusinessSettings/Components/Relation'));
const socialMediaIntegration = LazyWithRetry(import('./containers/SocialProfileSettings'));
const ContractManagementConfig = LazyWithRetry(import('./containers/BusinessSettings/Components/Contracts/ContractConfiguration'));
const ContractManagement = LazyWithRetry(import('./containers/BusinessSettings/Components/Contracts/TemplateLibrary/TemplateList/index'));
const Contract = LazyWithRetry(import('./containers/ContractManagement/index'));
const CreateNewTemplate = LazyWithRetry(import('./containers/BusinessSettings/Components/Contracts/ContractCreation/index'));
const ProfileSettings = LazyWithRetry(import('./containers/ProfileSettings/index'));
const DeviceManagement = LazyWithRetry(import('./containers/ProfileSettings/DeviceManagement/index'));
const LearningCertificate = LazyWithRetry(import('./containers/CertificationManagement/Components/LearningCertification/index'));
const InstructionPage = LazyWithRetry(import('./containers/CertificationManagement/Components/LearningCertification/InstructionPage'));
const Certifications = LazyWithRetry(import('./containers/CertificationManagement/index'));
const CertificationStatus = LazyWithRetry(import('./containers/CertificationManagement/Components/CertificateExamStatus/index'));
const MultipleCertifiedList = LazyWithRetry(import('./containers/CertificationManagement/Components/MultipleCertifiedList/index'));
const Networks = LazyWithRetry(import('./containers/Networks/index'));
const TLView = LazyWithRetry(import('./containers/BusinessSettings/Components/Contracts/TemplateLibrary/TemplateList/Components/TLView'));
const CMView = LazyWithRetry(import('./containers/ContractManagement/Components/CMView'));
const ContractSliderView = LazyWithRetry(import('./containers/BusinessSettings/Components/Contracts/Common/ContractSliderView/index'));
const DealopportunityDetail = LazyWithRetry(import('./containers/DealOpportunity/components/DealView'));
const NewUserResetPassword = LazyWithRetry(import('./AuthenticationPages/LoginPage/NewUserResetPassword'));
const VideoPlayer = LazyWithRetry(import('./containers/ResourceManagement/Components/VideoPlayer'));
const ContentDetailPage = LazyWithRetry(import('./containers/ResourceManagement/Components/ContentView/index'));
const CustomEdmCreation = LazyWithRetry(import('./containers/MediaDrive/components/CustomEdmCreation'));
const ProductWarranty = LazyWithRetry(import('./containers/ProductWarranty'));
const Meetings = LazyWithRetry(import('./containers/Meetings/index'));
const Webinar = LazyWithRetry(import('./containers/Webinar/index'));
const RegistrantsTable = LazyWithRetry(import('./containers/Webinar/Components/Registrants/index'));
const WebinaranalyticsLayout = LazyWithRetry(import('./containers/Webinar/Components/Analytics/index'));
const MeetingManagement = LazyWithRetry(import('./containers/BusinessSettings/Components/Meetings/ManagementMeetings/index'));
const WebinarManagement = LazyWithRetry(import('./containers/BusinessSettings/Components/Webinar/WebinarManagement/index'));
const MeetingsConfig = LazyWithRetry(import('./containers/BusinessSettings/Components/Meetings/ConfigurationMeetings/index'));
const WebinarConfig = LazyWithRetry(import('./containers/BusinessSettings/Components/Webinar/WebinarConfiguration/index'));
const NetworksConfig = LazyWithRetry(import('./containers/BusinessSettings/Components/Networks/index'));
const ConfigurationNewsFeed = LazyWithRetry(import('./containers/BusinessSettings/Components/NewsFeeds/index'));
const Helpandsupport = LazyWithRetry(import('./containers/HelpandSupport/index'));
const BusinessProfile = LazyWithRetry(import('./containers/BusinessProfile/index'));
const CompanyNetProfile = LazyWithRetry(import('./containers/Networks/Components/CompanyProfile/index'));
const BusinessDashboard = LazyWithRetry(import('./containers/BusinessSettings/Components/DashBoard/index'));
const Analytics = LazyWithRetry(import('./containers/BusinessSettings/Components/Analytics/index'));
const WebionarDetails = LazyWithRetry(import('./containers/Webinar/Components/WebinarDetails'));
const WebinarRegistrationPreview = LazyWithRetry(import('./containers/Webinar/Components/ScheduleWebinar/Components/WebinarRegistrationPreview'));
const GetFeedViewD = LazyWithRetry(import('./components/Hooks/s3updateNewCompRes'));
const EditEdmTemplate = LazyWithRetry(import('./containers/MediaDrive/components/CustomEdmTemplates/EditEdmTemplate'));
const CollaborationConfig = LazyWithRetry(import('./containers/BusinessSettings/Components/Collabaration/Configuration/Index'));
const CollaborationManagement = LazyWithRetry(import('./containers/BusinessSettings/Components/Collabaration/Management/index'));
const TaskAnalytics = LazyWithRetry(import('./containers/Collaboration/components/TaskAnalytics'));
const SocialMediaIntegrationOld = LazyWithRetry(import('./containers/BusinessSettings/Components/SocialMediaIntegration'));
// const SubCategories = LazyWithRetry(import('./containers/ResourcesRevised/Components/SubCategories/index'));
const ContentView = LazyWithRetry(import('./containers/ResourcesRevised/Components/ContentView/index'));
const ArticlePreview = LazyWithRetry(import('./components/Common/ArticlePreview'));
// const Playlists = LazyWithRetry(import('./containers/ResourcesRevised/Components/Playlists/index'));
const EmployeeDashboard = LazyWithRetry(import('./containers/EmployeeDashboard/index'));
const CompanyAnalytics = LazyWithRetry(import('./containers/EmployeeDashboard/CompanyAnalytics/index'));

const Login = AuthHoc(LoginPage);
const ForgotPasswordPage = AuthHoc(ForgotPassword);
const OtpVerifyPage = AuthHoc(OtpVerify);
const PasswordResetPage = AuthHoc(PasswordReset);
const SignupPage = AuthHoc(Signup);
const CompanyPage = AuthHoc(Company);
const Employeepage = AuthHoc(Employee);
const IndividualPage = AuthHoc(Individual);
const CompanySignUpPage = AuthHoc(CompanyNew);
const EmployeeSignUppage = AuthHoc(EmployeeNew);
const IndividualSignUpPage = AuthHoc(IndividualNew);
const SucessScreenpage = AuthHoc(SucessScreen);
const EmailChangeLayout = CompanyHoc(EmailChange);
const DepartmentViewLayout = CompanyHoc(Departmentview);
const NewsLayout = CompanyHoc(Newslist);
const EmpNetworkConnectionLayout = CompanyHoc(EmpNetworkConnection);
const CompanyPolicyLayOut = CompanyHoc(Policy);
const EmpManagementLayout = CompanyHoc(EmpManagement);
const EmpProfileLayout = CompanyHoc(EmpProfile);
// const ContactsLayout = CompanyHoc(Contacts);
const CollaborationMainLayout = CompanyHoc(Collaboration);

const OthersEmployeeProfileLayout = CompanyHoc(OthersEmployeeProfile);
const ContactsLayout = CompanyHoc(Contacts);
// const PendingRequestLayout = CompanyHoc(PendingRequest);
// const FollowingLayout = CompanyHoc(Following);
const LicenseManagementLayout = CompanyHoc(LicenseManagement);
const BuyLicensesCardsLayout = CompanyHoc(BuyLicensesCards);
const PlaceYourOrderLayout = CompanyHoc(PlaceYourOrder);
const SelfProfileLayout = CompanyHoc(SelfProfile);
const MyProfileLayout = CompanyHoc(MyProfile);
const DealopportunityLayout = CompanyHoc(Dealopportunity);
const ProductsLayout = CompanyHoc(Products);
const AffiliateManagementLayout = CompanyHoc(AffiliateManagement);
const AffiliateProductListLayout = CompanyHoc(AffiliateProductList);
const CommunicationLayout = CompanyHoc(Communication);
const CertExamLayout = CertificationExamHoc(ExamLayout);
const AffilaiteLayout = CompanyHoc(Affilaite);
const EmployeePendingLayout = EmployeePendingHoc(EmployeePending);
const AccessDeniedLayout = EmployeePendingHoc(AccessDenied);
const DealopportunityDetailLayout = CompanyHoc(DealopportunityDetail);
const DealviewDetailLayout = CompanyHoc(DealViewDetails);
const HighlightsLayout = CompanyHoc(Highlights);
const RecognitionLayout = CompanyHoc(Recognition);
const TrainingWebinarLayout = CompanyHoc(TrainingWebinar);
const TrainingDetailsLayout = CompanyHoc(TrainingDetails);
const ContentManagementLayout = CompanyHoc(ContentManagement);
const ContentManagementLayoutOld = CompanyHoc(ContentManagementOld);
const DocumentLayout = CompanyHoc(CreationDocument);
const VideoLayout = CompanyHoc(CreationVideo);
const PodcastLayout = CompanyHoc(CreationPodcast);
const ImageLayout = CompanyHoc(CreationImage);
const ArticleLayout = CompanyHoc(CreationArticle);
const ContentConfigLayout = CompanyHoc(ResourceConfig);
const ContentManageCategoriesLayout = CompanyHoc(ContentManagementCategiries);
// const ContentManageDraftsLayout = CompanyHoc(ContentManagementDrafts);
// const ContentManageUncategoryLayout = CompanyHoc(ContentManagementUncategory);
// const ContentManagePublishedLayout = CompanyHoc(ContentManagementPublished);
// const ContentManageUnpublishLayout = CompanyHoc(ContentManagementUnPublished);
// const ContentManageScheduleLayout = CompanyHoc(ContentManagementSchedule);
// const ContentManagePlayListLayout = CompanyHoc(ContentManagementPlaylist);
const CertificationManagementLayout = CompanyHoc(CertificationManagement);
const CertificationManViewLayout = CompanyHoc(CertificationManView);
const CreateCertificateLayout = CompanyHoc(CreateCertificate);
const CertificationsLayout = CompanyHoc(Certifications);
const LearningCertificateLayout = CompanyHoc(LearningCertificate);
const LearningScreenLayout = CompanyHoc(LearningScreen);
const ResourceManagementLayout = CompanyHoc(ResourceManagement);
const ResourceLayout = CompanyHoc(ResourceRevised);
const NewResourcesCategoryViewLayout = CompanyHoc(NewResourcesCategoryView);
const NewResourceContentCreationLayout = CompanyHoc(NewResourceContentCreation);
const NewResourceContentViewLayout = CompanyHoc(NewResourceContentView);
const ViewSubCategoryVideoLayout = CompanyHoc(ViewSubCategoryVideo);
const ViewSubCategoryContentLayout = CompanyHoc(ViewSubCategoryContent);
const ViewSubCategoryDocumentLayout = CompanyHoc(ViewSubCategoryDocument);
const ViewSubCategoryPodcastLayout = CompanyHoc(ViewSubCategoryPodcast);
const NewResourceCategoryViewLayout = CompanyHoc(NewResourceCategoryView);
const VideoPlayerLayOut = CompanyHoc(VideoPlayer);
const NetworkCompanyPageLayOut = CompanyHoc(NetworkCompanyPage);
const ContentDetailPageLayout = CompanyHoc(ContentDetailPage);
const BookSeatLayout = UnAuthHoc(BookSeat);
const RegistrationLayout = UnAuthHoc(Registration);
const RequestBookSeatLayout = UnAuthHoc(RequestBookSeat);
const LoginWebinarLayout = UnAuthHoc(LoginWebinar);
const JoinWebinarLayout = UnAuthHoc(JoinWebinar);
const StartTrainingLayout = UnAuthHoc(StartTraining);
const MediaDriveLayout = CompanyHoc(MediaDrive);
const NDeCreation = CompanyHoc(NewDesignCreation);
const CreateDesignLayout = CompanyHoc(CustomEdmCreation);
const BusinessProspectsEnablerLayout = CompanyHoc(BusinessProspectsEnabler);
const ProductWarrantyLayout = CompanyHoc(ProductWarranty);
const ProductWarrantySettingsLayout = CompanyHoc(ProductWarrantySettings);
const ProductWarrantyViewLayout = CompanyHoc(ProductWarrantyView);
const BussinessSettingsMenuLayout = CompanyHoc(BusinessSettingsMenu);
const SupportTicketLayout = CompanyHoc(SupportTicket);
const BussinessCertificateLayout = CompanyHoc(BussinessCertification);
const CustomLogoLayout = CompanyHoc(CustomLogo);
const DepartmentLayout = CompanyHoc(Department);
const ProductWarrantyLay = CompanyHoc(productWarranty);
const RelationLayout = CompanyHoc(Relation);
const SocialMediaIntegrationLayout = CompanyHoc(socialMediaIntegration);
const ContractLayout = CompanyHoc(Contract);
const ContractManagementLayout = CompanyHoc(ContractManagement);
const ContractManagementConfigLayout = CompanyHoc(ContractManagementConfig);
const CreateNewTemplateLayout = CompanyHoc(CreateNewTemplate);
const ProfileSettingsLayout = CompanyHoc(ProfileSettings);
const DeviceManagementLayout = CompanyHoc(DeviceManagement);
const ChangePasswordLayout = CompanyHoc(ChangePassword);
const LanguagesLayout = CompanyHoc(Languages);
const OutsideInlynkLayout = CompanyHoc(OutsideInlynk);
const InsideInLynkLayout = CompanyHoc(InsideinLynk);
const CertificationStatusLayout = CertificationExamHoc(CertificationStatus);
const MultipleCertifiedLayout = CompanyHoc(MultipleCertifiedList);
const TLViewLayout = CompanyHoc(TLView);
const CMViewLayout = CompanyHoc(CMView);
// const HTMLTemplateLayout = CompanyHoc(HTMLTemplate);
// const HTMLTemplateTwoLayout = CompanyHoc(HTMLTemplateTwo);
// const HTMLTemplateThreeLayout = CompanyHoc(HTMLTemplateThree);
// const HTMLTemplateFourLayout = CompanyHoc(HTMLTemplateFour);
// const HTMLTemplateFiveLayout = CompanyHoc(HTMLTemplateFive);
// const HTMLTemplateSixLayout = CompanyHoc(HTMLTemplateSix);
const HelpandSupportLayout = CompanyHoc(Helpandsupport);
const BusinessDashboardLayout = CompanyHoc(BusinessDashboard);
const AnalyticsLayout = CompanyHoc(Analytics);
const EmployeeDashboardLayout = CompanyHoc(EmployeeDashboard);
const BusinessProfileLayout = CompanyHoc(BusinessProfile);
const CompanyNetProfileLayout = CompanyHoc(CompanyNetProfile);
const NetworksLayout = CompanyHoc(Networks);
const MeetingsLayOut = CompanyHoc(Meetings);
const WebinarLayout = CompanyHoc(Webinar);
const RegistrantsTableLayout = CompanyHoc(RegistrantsTable);
const WebinarAnalyticsLayout = CompanyHoc(WebinaranalyticsLayout);
const MeetingManagementLayout = CompanyHoc(MeetingManagement);
const WebinarManagementLayout = CompanyHoc(WebinarManagement);
const MeetingConfigLayout = CompanyHoc(MeetingsConfig);
const WebinarConfigLayout = CompanyHoc(WebinarConfig);
const NetworksConfigLayout = CompanyHoc(NetworksConfig);
const NewsFeedConfigLayout = CompanyHoc(ConfigurationNewsFeed);
const WebionarDetailsPage = CompanyHoc(WebionarDetails);
const WebinarCreation = CompanyHoc(ScheduleLayout);
const EditEdmTemplateLayout = CompanyHoc(EditEdmTemplate);
const CollaborationConfigLayout = CompanyHoc(CollaborationConfig);
const CollaborationManageLayout = CompanyHoc(CollaborationManagement);
const TaskAnalyticsLayout = CompanyHoc(TaskAnalytics);
const SocialMediaIntegrationOldLayout = CompanyHoc(SocialMediaIntegrationOld);
const CompanyAnalyticsLayout = CompanyHoc(CompanyAnalytics);

// Super Admin Route Wrapper
const SuperAdminRoute = ({ children }) =>
{
	const userData = useSelector((state:any) => state?.mysession?.session);
	const isSuperAdmin = userData?.empRole === 'superAdmin';

	// If no user data, redirect to login
	if (!userData || Object.keys(userData || {}).length === 0)
	{
		return <Navigate to='/' replace />;
	}

	// If not super admin, show error and redirect
	if (!isSuperAdmin)
	{
		toast.error('Access denied. You do not have permission to view this page.');

		return <Navigate to={'/news'} replace />;
	}

	return children;
};

// Admin/Super Admin Route Wrapper
const AdminRoute = ({ children }) =>
{
	const userData = useSelector((state:any) => state?.mysession?.session);
	const isAdminSuperAdmin = roleCondition(userData?.empRole);

	// If no user data, redirect to login
	if (!userData || Object.keys(userData || {}).length === 0)
	{
		return <Navigate to='/' replace />;
	}

	// If not admin/super admin, show error and redirect
	if (!isAdminSuperAdmin)
	{
		toast.error('Access denied. You do not have permission to view this page.');

		return <Navigate to={'/news'} replace />;
	}

	return children;
};

// Dashboard Admin Route Wrapper (role-based admin OR dashboardManagement admin)
const DashboardAdminRoute = ({ children }) =>
{
	const userData = useSelector((state:any) => state?.mysession?.session);
	const userConfigs = useSelector((state:any) => state?.mysession?.userConfigs);
	const isSuperAdmin = userData?.empRole === 'superAdmin';
	const isDashboardAdmin = userConfigs?.dashboardManagement?.isAdmin;

	// If user is logged out (no session), redirect to login
	if (!userData || Object.keys(userData).length === 0)
	{
		return <Navigate to={'/'} replace />;
	}

	// Wait for user data to load
	if (Object.keys(userConfigs ?? {}).length === 0 || !userData?.userId)
	{
		return <Loading />;
	}

	// If user doesn't have access, show error and redirect
	if (!isSuperAdmin && !isDashboardAdmin)
	{
		toast.error('Access denied. You do not have permission to view this page.');

		return <Navigate to={'/news'} replace />;
	}

	return children;
};

const EmployeeRoute = ({ children }) =>
{
	const userData = useSelector((state:any) => state?.mysession?.session);
	const isEmployee = (userData?.role === 'employee' && userData?.empRole === 'employee');

	// If no user data, redirect to login
	if (!userData || Object.keys(userData || {}).length === 0)
	{
		return <Navigate to='/' replace />;
	}

	// If not employee, show error and redirect
	if (!isEmployee)
	{
		toast.error('Access denied. You do not have permission to view this page.');

		return <Navigate to={'/news'} replace />;
	}

	return children;
};

// Route guard for Business Prospects - restricts access based on role and configuration
const BusinessProspectsRoute = ({ children }) =>
{
	const userData = useSelector((state:any) => state?.mysession?.session);
	const accessConfigs = useSelector((state:any) => state?.mysession?.otherConfigs);
	// Use ref to track if error has been shown (persists across re-renders)
	const errorShownRef = useRef(false);

	// Wait for user data to load
	if (Object.keys(userData || {}).length === 0 || !userData?.userId)
	{
		return <Loading />;
	}

	const isAdmin = roleCondition(userData?.empRole);

	if (!isAdmin)
	{
		const hasConfigsData = accessConfigs && Object.keys(accessConfigs).length > 0;
		const hasProspectsAccess = accessConfigs?.prospectsAccess !== undefined;
		const isConfigsLoaded = hasConfigsData || hasProspectsAccess;

		if (!isConfigsLoaded)
		{
			return <Loading />;
		}
	}

	// Check if user has access to business prospects
	const hasAccess = canAccessBusinessProspects(userData, accessConfigs);

	if (!hasAccess)
	{
		// Only show error toast once
		if (!errorShownRef.current)
		{
			errorShownRef.current = true;
			toast.error('Access denied. You do not have permission to view Business Prospects.');
		}

		return <Navigate to={'/news'} replace />;
	}

	// Reset error flag if access is granted (in case user switches accounts or configs change)
	errorShownRef.current = false;

	return children;
};

// const SubCategoriesLayout = CompanyHoc(SubCategories);
const ContentViewLayout = CompanyHoc(ContentView);
// const PlaylistLayout = CompanyHoc(Playlists);
const ContentSectionViewLayout = CompanyHoc(ContentSectionView);
const ArticleViewPageLayout = CompanyHoc(ArticleViewPage);
const DocumentViewPageLayout = CompanyHoc(DocumentViewPage);
const PodcastViewPageLayout = CompanyHoc(PodcastViewPage);
const VideoViewPageLayout = CompanyHoc(VideoViewPage);
const ImageViewPageLayout = CompanyHoc(ImageViewPage);
const PlaylistViewPageLayout = CompanyHoc(PlaylistViewPage);

function NavRoutes()
{
	const userData = useSelector((state: any) => state?.mysession?.session);
	const userConfigs = useSelector((state: any) => state?.mysession?.userConfigs);
	const deal = useSelector((state: any) => state?.mysession?.deal);
	const role: any = new URLSearchParams(window.location.search).get('role');

	const isSuperAdmin = userData?.empRole === 'superAdmin';
	const isAdminSuperAdmin = roleCondition(userData?.empRole);
	const isIndividual = userData?.role === 'individual';
	const viewContractAccess = userConfigs?.contractAccess?.isContractEmp && (userConfigs?.contractAccess?.viewContract || userConfigs?.contractAccess?.createTemplate || userConfigs?.contractAccess?.templateApprove);
	const isContractMenuEnable = userConfigs?.contractAccess?.isContractEmp && (userConfigs?.contractAccess?.viewContract || userConfigs?.contractAccess?.authorization);
	const isProductWarranty = userData?.companyData?.warrantyManagement?.analytics && userData?.companyData?.warrantyManagement?.configuration;

	// Check if user is logged in and userConfigs is still loading
	const isUserLoggedIn = userData && Object.keys(userData).length > 0;
	const isConfigLoading = isUserLoggedIn && !userConfigs?.contractAccess;

	useRouteHelper();

	return (
		<React.Suspense fallback={<Loading />}>
			<BrowserRouter>
				<HeaderSidebarLayoutHoc>
					<Routes>
						<Route path='/' element={<Login />} />
						<Route path='/declined' element={<DeclinedAccess />} />
						<Route path='/forgot' element={<ForgotPasswordPage />} />
						<Route path='/reset-password' element={<PasswordResetPage />} />
						<Route path='/newUserResetPassword' element={<NewUserResetPassword />} />
						<Route path='/success-screen' element={<SucessScreenpage />} />
						<Route path='/otp-verify' element={<OtpVerifyPage />} />
						<Route path='/signup' element={<SignupPage />} />
						<Route path='/company/:companyId?/:userId?' element={<CompanyPage />} />
						<Route path='/employee/:id?' element={<Employeepage />} />
						<Route path='/individual/:companyId?/:userId?' element={<IndividualPage />} />
						<Route path='/training' element={<TrainingWebinarLayout />} />
						<Route path='/training/trainingDetails/:meetingId?/:tab?' element={<TrainingDetailsLayout />} />
						<Route path='/training/:tab?' element={<TrainingWebinarLayout />} />
						<Route path='/meetings' element={<MeetingsLayOut />} />
						{/* <Route path='/taskmangement' element={<TaskMangementLayout />} /> */}
						{/* <Route path='/userSign' element={<SignUp/>}/> */}
						<Route path='/company-signup' element={<CompanySignUpPage/>}/>
						<Route path='/employee-signup' element={<EmployeeSignUppage/>}/>
						<Route path='/individual-signup' element={<IndividualSignUpPage/>}/>
						{/* Business Settings Routes */}
						{/* Super Admin Only Routes */}
						<Route path='/businessSettings/menu' element={<SuperAdminRoute><BussinessSettingsMenuLayout/></SuperAdminRoute>}/>
						<Route path='/businessSettings/productWarranty' element={<SuperAdminRoute><ProductWarrantyLay/></SuperAdminRoute>}/>
						<Route path='/businessSettings/feedsconfiguration' element={<SuperAdminRoute><NewsFeedConfigLayout/></SuperAdminRoute>}/>
						<Route path='/businessSettings/bussinessCertification/:id?' element={<SuperAdminRoute><BussinessCertificateLayout/></SuperAdminRoute>}/>
						<Route path='/businessSettings/certificationManagement/certificateConfig/:id?' element={<SuperAdminRoute><BussinessCertificateLayout/></SuperAdminRoute>}/>
						<Route path='/businessSettings/contractManagement/contractMngtConfigure' element={<SuperAdminRoute><ContractManagementConfigLayout/></SuperAdminRoute>}/>
						<Route path='/businessSettings/meetingManagement/meetingConfigure' element={<SuperAdminRoute><MeetingConfigLayout/></SuperAdminRoute>}/>
						<Route path='/businessSettings/webinarManagement/webinarConfigure' element={<SuperAdminRoute><WebinarConfigLayout/></SuperAdminRoute>}/>
						<Route path='/businessSettings/networksConfigure' element={<SuperAdminRoute><NetworksConfigLayout/></SuperAdminRoute>}/>
						{/* <Route path='/businessSettings/collaborationManageMent/collaborationConfig' element={<SuperAdminRoute><CollaborationConfigLayout/></SuperAdminRoute>}/>
					<Route path='/businessSettings/collaborationManageMent' element={<SuperAdminRoute><CollaborationManageLayout/></SuperAdminRoute>}/> */}
						<Route path='/businessSettings/socialMediaIntegration' element={<SuperAdminRoute><SocialMediaIntegrationLayout/></SuperAdminRoute>}/>

						{/* Admin/Super Admin Routes */}
						<Route path='/businessSettings/recognition' element={<AdminRoute><RecognitionLayout /></AdminRoute>} />
						<Route path='/businessSettings/customLogo' element={<AdminRoute><CustomLogoLayout/></AdminRoute>}/>
						<Route path='/businessSettings/department' element={<AdminRoute><DepartmentLayout/></AdminRoute>}/>
						<Route path='/businessSettings/relation' element={<AdminRoute><RelationLayout/></AdminRoute>}/>
						<Route path='/businessSettings/department/view/:id?' element={<AdminRoute><DepartmentViewLayout /></AdminRoute>} />
						<Route path='/businessSettings/businessDashboard' element={<DashboardAdminRoute><BusinessDashboardLayout /></DashboardAdminRoute>} />
						<Route path='/dashboard/:companyId?/:employeeId?' element={<EmployeeDashboardLayout />} />
						<Route path='/businessSettings/businessProfile' element={<AdminRoute><BusinessProfileLayout /></AdminRoute>} />
						<Route path='/businessSettings/employees' element={<AdminRoute><EmpManagementLayout/></AdminRoute>}/>
						<Route path='/businessSettings/analytics' element={<AdminRoute><AnalyticsLayout/></AdminRoute>}/>
						<Route path='/businessSettings/employees/connections/:id?' element={<AdminRoute><EmpNetworkConnectionLayout/></AdminRoute>}/>
						<Route path='/businessSettings/employees/profile/:id?' element={<AdminRoute><EmpProfileLayout/></AdminRoute>}/>
						{/* old content management routes -- need to remove later */}
						<Route path='/businessSettings/contentold' element={<ContentManagementLayoutOld />}/>
						<Route path='/businessSettings/content/category/:categoryId?' element={<NewResourcesCategoryViewLayout/>}/>
						<Route path='/businessSettings/content/contentCreation' element={<NewResourceContentCreationLayout/>}/>
						<Route path='/businessSettings/content/contentView' element={<NewResourceContentViewLayout/>}/>
						{/* New Resources Routes For ContentManagment  */}
						<Route path='/businessSettings/content' element={<ContentManagementLayout />}/>
						<Route path='/businessSettings/content/documents' element={<ContentRouteWrapper isCreation contentType='documents'><DocumentLayout /></ContentRouteWrapper>} />
						<Route path='/businessSettings/content/video' element={<ContentRouteWrapper isCreation contentType='videos'><VideoLayout /></ContentRouteWrapper>} />
						<Route path='/businessSettings/content/podcast' element={<ContentRouteWrapper isCreation contentType='podcasts'><PodcastLayout /></ContentRouteWrapper>} />
						<Route path='/businessSettings/content/image' element={<ContentRouteWrapper isCreation contentType='images'><ImageLayout /></ContentRouteWrapper>} />

						<Route path='/businessSettings/content/articleCreation' element={<ContentRouteWrapper isCreation contentType='articles'><ArticleLayout /></ContentRouteWrapper>} />
						<Route path='/businessSettings/content/editArticle/:id?' element={<ContentRouteWrapper isEdit contentType='articles'><ArticleLayout /></ContentRouteWrapper>} />
						<Route path='/businessSettings/contentConfig' element={<ContentConfigLayout />} />
						<Route path='/businessSettings/content/categories/:categoryId?' element={<ContentManageCategoriesLayout />} />
						<Route path='/businessSettings/content/contentCreation' element={<AdminRoute><NewResourceContentCreationLayout/></AdminRoute>}/>
						<Route path='/businessSettings/content/contentView' element={<AdminRoute><NewResourceContentViewLayout/></AdminRoute>}/>
						{/* New Resources Routes For CertificationManagement  */}
						<Route path='/businessSettings/certificationManagement/:type?/:id?' element={<AdminRoute><CertificationManagementLayout /></AdminRoute>}/>
						<Route path='/businessSettings/certificationManagement/certificationView/:id?/:isEnable?' element={<AdminRoute><CertificationManViewLayout /></AdminRoute>}/>
						<Route path='/businessSettings/certificationManagement/createcertification' element={<AdminRoute><CreateCertificateLayout /></AdminRoute>}/>
						<Route path='/businessSettings/certificationManagement/upateCertificate/:type?/:id?' element={<AdminRoute><CreateCertificateLayout /></AdminRoute>}/>
						<Route path='/connections/employee/:id' element={<AdminRoute><OthersEmployeeProfileLayout/></AdminRoute>}/>

						{!isIndividual &&
						<>
							<Route path='/deal' element={<DealopportunityLayout />} />
							{/* New Resources Routes For Resource View  */}
							<Route path='/resource/network/:companyId?' element={<ResourceLayout />} />
							<Route path='/resource/network/companies/:companyId?/:type?/:categoryId?' element={<ResourceLayout />} />
							<Route path='/resource/:type?/:categoryId?' element={<ResourceLayout />} />
							{/* <Route path='/resource/categories/:categoryId?' element={<ResourceLayout />} /> */}
							{/* <Route path='/resource/mynetworks' element={<ResourceLayout />} />
							<Route path='/resource/favorites' element={<ResourceLayout />} />
							<Route path='/resource/playlist' element={<ResourceLayout />} /> */}
							{/* <Route path='/resource/categories/:categoryId?' element={<SubCategoriesLayout />} />
							<Route path='/resource/mynetworks' element={<SubCategoriesLayout />} />
							<Route path='/resource/favorites' element={<SubCategoriesLayout />} />
							<Route path='/resource/playlist' element={<SubCategoriesLayout />} /> */}
							{/* <Route path='/resource/playlist' element={<PlaylistLayout />} /> */}
							{/* <Route path='/resource/subCategories/:viewType?/:companyId?' element={<SubCategoriesLayout />} /> */}
							<Route path='/resource/view/:viewType?/:contentId?' element={<ContentRouteWrapper contentType={undefined}><ContentViewLayout /></ContentRouteWrapper>} />
							<Route path='/resource/network/view/:companyId?/:viewType?/:contentId?' element={<ContentViewLayout />} />
							<Route path='/resource/subCategories/view/:viewType?/:companyId?' element={<ContentViewLayout />} />

							{/* old resource paths */}

							{/* <Route path='/resourcemanagement/' element={<ResourceManagementLayout />} />
							<Route path='/resourcemanagement/video/:categoryId?' element={<ViewSubCategoryVideoLayout />} />
							<Route path='/resourcemanagement/content/:categoryId?' element={<ViewSubCategoryContentLayout />} />
							<Route path='/resourcemanagement/document/:categoryId?' element={<ViewSubCategoryDocumentLayout />} />
							<Route path='/resourcemanagement/podcast/:categoryId?' element={<ViewSubCategoryPodcastLayout />} />
							<Route path='/resourcemanagement/videos/:view?/:videoId?/:selectId?' element={<VideoPlayerLayOut />} />
							<Route path='/resourcemanagement/videos/:view?/:videoId?/:companyId?/:relationId?/:selectId?' element={<VideoPlayerLayOut />} />
							<Route path='/resourcemanagement/categories/:type?' element={<NewResourceCategoryViewLayout />} />
							<Route path='/resourcemanagement/contents/:view?/:categoryId?/:contentId?/:companyId?/:relationId?' element={<ContentDetailPageLayout />} />
							
							{/* network resources paths */}

							{/* <Route path='/resourcemanagement/network' element={<ResourceManagementLayout />} />
							<Route path='/resourcemanagement/content/networkview/:companyId?/:contentId?' element={<ContentDetailPageLayout />} />
							<Route path='/resourcemanagement/:type?/:companyId?/:relationId?/:categoryId?' element={<NetworkCompanyPageLayOut />} />
							<Route path='/resourcemanagement/:companyId?' element={<NetworkCompanyPageLayOut />} /> 
							{ /* License Management */}
							<Route path='/license-management' element={<LicenseManagementLayout />} />
							<Route path='/pricing' element={<BuyLicensesCardsLayout />} />
							<Route path='/place-your-order' element={<PlaceYourOrderLayout />} />
							{/* people */}
							<Route path='/collaboration' element={<CollaborationMainLayout />} />
							{/* <Route path='/contacts' element={<ContactsLayout/>}/>
						<Route path='/tasks/tasks_analytics' element={<TaskMangementLayout/>}/> */}
							{/* <Route path='/contacts' element={<ContactsLayout />} /> */}
							<Route path='/tasks/tasks_analytics' element={<TaskAnalyticsLayout />} />
							<Route path='/tasks/:id?' element={<CommunicationLayout />} />
							<Route path='/createNewTemplate/:selected?/:id?' element={<CreateNewTemplateLayout />} />
							<Route path='/createNewTemplate/duplicateTemplate/:selected?/:id?' element={<CreateNewTemplateLayout />} />
							{isConfigLoading &&
								(
									<>
										<Route path='/contractManagement/:selected?' element={<Loading />} />
										<Route path='/contractManagement/view/:templateId?/:selected?' element={<Loading />} />
										<Route path='/businessSettings/contractManagement/view/:templateId?/:selected?' element={<Loading />} />
										<Route path='/businessSettings/contractManagement/preview/:selected?' element={<Loading />} />
									</>
								)}
							{isContractMenuEnable &&
								<>
									<Route path='/contractManagement/:selected?' element={<ContractLayout />} />
									<Route path='/contractManagement/view/:templateId?/:selected?' element={<CMViewLayout />} />
								</>
							}
							{viewContractAccess &&
								<>
									<Route path='/businessSettings/contractManagement/view/:templateId?/:selected?' element={<TLViewLayout />} />
									<Route path='/businessSettings/contractManagement/preview/:selected?' element={<ContractManagementLayout />} />
								</>
							}
							<Route path='/supportTicketing' element={<SupportTicketLayout />} />
							<Route path='/businessSettings/contractManagement/:templateId?' element={<ContractManagementLayout />} />
							<Route path='/connections/profile/view/:templateId?/:comId?' element={<TLViewLayout />} />
							<Route path='/profileSettings' element={<ProfileSettingsLayout />} />
							<Route path='/profileSettings/changePassword' element={<ChangePasswordLayout />} />
							<Route path='/profileSettings/languages' element={<LanguagesLayout />} />
							<Route path='/profileSettings/deviceManagement' element={<DeviceManagementLayout />} />
							<Route path='/profileSettings/emailChange' element={<EmailChangeLayout />} />
							{ /* Affiliate Management */}
							<Route path='/affiliate-management' element={<AffiliateManagementLayout />} />
							<Route path='/affiliate-management/ProductsList' element={<AffiliateProductListLayout />} />
							{/* certification */}
							<Route path='/certificationExam' element={<CertExamLayout />} />
							<Route path='/certification/certificationManagement/:type?/:id?' element={<CertificationManagementLayout />} />
							<Route path='/certification/viewcertified/:id?' element={<MultipleCertifiedLayout />} />
							<Route path='/businessSettings/certificationView' element={<CertificationManViewLayout />} />
							<Route path='/certification/certificationView/:id?' element={<CertificationManViewLayout />} />
							<Route path='/examStatus/:id?' element={<CertificationStatusLayout />} />
							<Route path='/profileSettings/socialMediaIntegration' element={<SocialMediaIntegrationLayout />} />
							<Route path='/drive/design/:tab?/:folderId?/:edit?' element={<CreateDesignLayout />} />
							<Route path='/drive' element={<MediaDriveLayout />} />
							{/* <Route path='/drive/edit/:tab?/:id?/:folderId?' element={<NDeCreation/>}/> */}
							<Route path='/drive/empF/:tab?/:userId?/:id?' element={<MediaDriveLayout />} />
							<Route path='/drive/:tab?/:id?' element={<MediaDriveLayout />} />
							<Route path='/dealviewDetails/:id?' element={<DealviewDetailLayout />} />
							<Route path='/certification/learningcertificate/:id?' element={<LearningCertificateLayout />} />
							<Route path='/certification/learningscreen/:id?/:materialId?' element={<LearningScreenLayout />} />
							<Route path='/certification/startexam/:id?' element={<InstructionPage />} />
							<Route path='/certification' element={<CertificationsLayout />} />
							<Route path='/certification/:companyName?/:from?/:id?' element={<CertificationsLayout />} />
							<Route path='/businessSettings/meetingManagement' element={<MeetingManagementLayout />} />
							<Route path='/businessSettings/webinarManagement' element={<WebinarManagementLayout />} />
							<Route path='/helpandsupport' element={<HelpandSupportLayout />} />
							<Route path='/businessProfile' element={<BusinessProfileLayout />} />
							<Route path='/meetingvc/:session?' element={<MeetingVc />} />
						</>
						}
						{deal?.dealStatus && userData?.role !== 'individual' &&
						<Route path='/deal/view/detailView' element={<DealopportunityDetailLayout />} />
						}
						{userData.role === 'company' &&
						<Route path='/policy' element={<CompanyPolicyLayOut />} />
						}

						<Route path='/news/:type?/:item?' element={<NewsLayout />} />
						<Route path='/profile' element={<BusinessProfileLayout />} />
						<Route path='/emp' element={<EmployeePendingLayout />} />
						<Route path='/accessdenied' element={<AccessDeniedLayout />} />
						<Route path='/me' element={<SelfProfileLayout />} />
						<Route path='/products' element={<ProductsLayout />} />
						<Route path='/highlights' element={<HighlightsLayout />} />
						<Route path='/highlights/:id?/:eventType?' element={<HighlightsLayout />} />
						{(userData?.role === 'individual' || isProductWarranty) &&
						<>
							<Route path='/productWarranty' element={<ProductWarrantyLayout />} />
							<Route path='/productWarranty/view/:companyId?/:id?' element={<ProductWarrantyViewLayout />} />
							<Route path='/productWarranty/settings' element={< ProductWarrantySettingsLayout />} />
						</>
						}
						<Route path='/productWarranty' element={<ProductWarrantyLayout />} />
						<Route path='/productWarranty/view/:companyId?/:id?' element={<ProductWarrantyViewLayout />} />
						<Route path='/productWarranty/settings' element={< ProductWarrantySettingsLayout />} />
						{/* <Route path='/connections/pendingRequest' element={<PendingRequestLayout />}/> check for use*/}
						{/* <Route path='/connections/followingList' element={<FollowingLayout/>}/> check for use */}
						<Route path='/connections/companyprofile/:id?/:tabValue?/:employeeId?' element={<CompanyNetProfileLayout />} />
						<Route path='/connections/companyprofile/content/:relationId?/:id?/:tabValue?' element={<CompanyNetProfileLayout />} />
						<Route path='/connections' element={<NetworksLayout />} />
						<Route path='/profileSettings' element={<ProfileSettingsLayout />} />
						<Route path='/profileSettings/profile' element={<MyProfileLayout />} />
						<Route path='/profileSettings/changePassword' element={<ChangePasswordLayout />} />
						<Route path='/profileSettings/languages' element={<LanguagesLayout />} />
						<Route path='/profileSettings/deviceManagement' element={<DeviceManagementLayout />} />
						<Route path='affiliate' element={<AffilaiteLayout />} />
						<Route path='/conference/register/:id?' element={role && ([ 2, 3 ]?.includes(Number(role))) ? <JoinWebinarLayout /> : <BookSeatLayout />} />
						<Route path='/conference/join/:id?' element={<JoinWebinarLayout />} />
						<Route path='/conference/join-guest/:id?' element={<LoginWebinarLayout />} />
						<Route path='/conference/success/:id?' element={<RegistrationLayout />} />
						<Route path='/conference/request/:id?' element={<RequestBookSeatLayout />} />
						<Route path='/joinvc/starttraining' element={<StartTrainingLayout />} />
						<Route path='/join-confernece/:id?' element={<TraningWebnirScreen />} />
						<Route path='/businessprospects/listview?/:id?/:tab?' element={<BusinessProspectsRoute><BusinessProspectsEnablerLayout /></BusinessProspectsRoute>} />
						<Route path='/custom/:url?' element={<InsideInLynkLayout />} />
						<Route path='/outroute/:url?' element={<OutsideInlynkLayout />} />
						<Route path='/contract/mobile/sign/:templateId?' element={<CMView />} />
						<Route path='/contract/mobile/intiate/:templateId?/:date?' element={<ContractSliderView />} />
						<Route path='/contract/mobile/view/:templateId?/:date?' element={<TLView />} />
						<Route path='/brandingPreview' element={<BrandingPreview />} />
						<Route path='/registrationPreview/:id' element={<RegisterPreview />} />
						<Route path='/webinars' element={<WebinarLayout />} />
						<Route path='/webinar/:status' element={<RegistrantsTableLayout />} />
						<Route path='/webinars/analytics/:id' element={<WebinarAnalyticsLayout />} />
						<Route path='/webinars/view/:id' element={<WebionarDetailsPage />} />
						<Route path='/webinars/:type' element={<WebinarCreation />} />
						<Route path='/businessSettings/content/section-view' element={<ContentSectionViewLayout />} />
						<Route path='/businessSettings/content/article-view' element={<ContentRouteWrapper contentType='articles'><ArticleViewPageLayout /></ContentRouteWrapper>} />
						<Route path='/businessSettings/content/document-view' element={<ContentRouteWrapper contentType='documents'><DocumentViewPageLayout /></ContentRouteWrapper>} />
						<Route path='/businessSettings/content/podcast-view' element={<ContentRouteWrapper contentType='podcasts'><PodcastViewPageLayout /></ContentRouteWrapper>} />
						<Route path='/businessSettings/content/video-view' element={<ContentRouteWrapper contentType='videos'><VideoViewPageLayout /></ContentRouteWrapper>} />
						<Route path='/businessSettings/content/image-view' element={<ContentRouteWrapper contentType='images'><ImageViewPageLayout /></ContentRouteWrapper>} />
						<Route path='/businessSettings/content/playlist-view' element={<ContentRouteWrapper contentType='playlists'><PlaylistViewPageLayout /></ContentRouteWrapper>} />

						<Route path='*' element={<PageNotFound />} />
						<Route path='*' element={<DeclinedAccess />} />
						<Route path='/drive/edit/:type?/:index?/:imageKey?' element={<EditEdmTemplateLayout />} />
						{/* <Route path='/drive/edit/:type?/:index?' element={<HTMLTemplateLayout />}/> */}
						<Route path='/webiner/waitingpage/:id' element={<BrandingPreview />} />
						<Route path='/webinars/:type/:id?' element={<RegisterPreview />} />
						<Route path='/webinarsvc/:type/:session?' element={<WebinarVc />} />
						<Route path='/meetingvc/:type?/:session?' element={<MeetingVc />} />
						<Route path='/articleview/:id?' element={<ArticlePreview />} />
						{/* <Route path='/mediaDriveTemplateTwo' element={<HTMLTemplateTwoLayout />}/>
					<Route path='/mediaDriveTemplateThree' element={<HTMLTemplateThreeLayout />}/>
					<Route path='/mediaDriveTemplateFour' element={<HTMLTemplateFourLayout />}/>
					<Route path='/mediaDriveTemplateFive' element={<HTMLTemplateFiveLayout />}/>
					<Route path='/mediaDriveTemplateSix' element={<HTMLTemplateSixLayout />}/> */}
					</Routes>
				</HeaderSidebarLayoutHoc>
			</BrowserRouter>
		</React.Suspense>

	);
}
export default memo(NavRoutes);